<template>
  <div>
    <h5 v-if="title != null">
      {{ title }}
      <span v-if="modified" class="ml-1 text-muted" @click="$emit('reset')"><i class="fas fa-times-circle"></i></span>
      <span class="ml-1 text-muted small" @click="$emit('clear')">(clear)</span>
    </h5>
    <div v-for="(option, index) in options" v-bind:key="index" :class="'form-check mb-2' + (inline ? ' form-check-inline' : '')">
      <input class="form-check-input" v-model="value" v-on:input="$emit('input', $event.target.value)" type="radio" :name="safeName" :id="safeId(index)" :value="option.value">
      <label class="form-check-label ml-1 mr-2" :for="safeId(index)" :title="option.tooltip != null ? option.tooltip : option.label">
        {{ option.label == null ? option.value : option.label }}
        <small v-if="option.count != null" class="text-muted ml-1">({{ option.count }})</small>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "InlineRadioOptions",
  
  props: {
    inline: Boolean,
    title: String,
    name: String,
    options: Array,
    value: String,
    modified: Boolean
  },
  
  methods: {
    safeId(index) {
      return this.safeName + '-' + index;
    }
  },
  
  computed: {
    safeName() {
      return this.name + "Options";
    }
  }
}
</script>
